import React from 'react'
import PropTypes from 'prop-types'
import {get} from 'lodash'
import className from 'classnames'
import dynamic from 'next/dynamic'

import {t} from '@lib/helpers'

const Meta = dynamic(() => import('@components/Meta'))

const PolicySecurity = ({contentKey}) => {
  return (
    <React.Fragment>
      <Meta
        title={`${t(`pages.${contentKey}.title`)} – ${t('layout.title')}`}
      />

      <div className='Policy'>
        <div className='BodySpace'>
          <div className='Policy__hero'>
            <div className='container'>
              <h2
                className='Policy__hero__h2'
                dangerouslySetInnerHTML={{
                  __html: t(`pages.${contentKey}.hero.h2`),
                }}
              />

              <div className='Policy__hero__ps'>
                {t(`pages.${contentKey}.hero.p`).map((x, i) => (
                  <p
                    className='Policy__hero__p'
                    key={i}
                    dangerouslySetInnerHTML={{
                      __html: x,
                    }}
                  ></p>
                ))}
              </div>
            </div>
          </div>

          <div className='Policy__content'>
            <div className='container'>
              <dl className='Policy__content__dl'>
                {t(`pages.${contentKey}.content.dl`).map((x, i) => (
                  <div className='Policy__content__dl__item' key={i}>
                    <dt className='Policy__content__dl__item__dt'>
                      <h3>{get(x, 'dt')}</h3>
                    </dt>

                    <dd className='Policy__content__dl__item__dd'>
                      {get(x, 'dd').map((y, j) => (
                        <React.Fragment key={j}>
                          {get(y, 'label') ? (
                            <p
                              className='Policy__content__dl__item__dd__p'
                              dangerouslySetInnerHTML={{
                                __html: get(y, 'label'),
                              }}
                            ></p>
                          ) : get(y, 'ul') ? (
                            <ul className='Policy__content__dl__item__dd__ul'>
                              {(get(y, 'ul') || []).map((z, k) => (
                                <li
                                  className='Policy__content__dl__item__dd__ul__li'
                                  key={k}
                                  dangerouslySetInnerHTML={{
                                    __html: z,
                                  }}
                                ></li>
                              ))}
                            </ul>
                          ) : get(y, 'ol') ? (
                            <ul className='Policy__content__dl__item__dd__ol'>
                              {(get(y, 'ol') || []).map((z, k) => (
                                <li
                                  className='Policy__content__dl__item__dd__ol__li'
                                  key={k}
                                  dangerouslySetInnerHTML={{
                                    __html: z,
                                  }}
                                ></li>
                              ))}
                            </ul>
                          ) : get(y, 'h4') ? (
                            <h4 className='Policy__content__dl__item__dd__h4'>
                              {get(y, 'h4')}
                            </h4>
                          ) : null}
                        </React.Fragment>
                      ))}
                      {t(`pages.${contentKey}.content.dl`).length - 1 > i && (
                        <hr />
                      )}
                    </dd>
                  </div>
                ))}
              </dl>
            </div>
          </div>
        </div>
      </div>
    </React.Fragment>
  )
}

PolicySecurity.propTypes = {}

export default PolicySecurity
